import {Component, Input, OnInit} from '@angular/core';
import {QuoteCollation, QuotePageDataVaps} from '../../../models/quote.model';
import {Question} from '../../../models/underwriter.model';

@Component({
    selector: 'app-vaps-location-three-buildings',
    templateUrl: './vaps-location-three-buildings.component.html',
    styleUrls: ['./vaps-location-three-buildings.component.scss'],
    standalone: false
})
export class VapsLocationThreeBuildingsComponent implements OnInit {

  @Input() collations: QuoteCollation[];
  @Input() question: Question;
  @Input() currentVap: QuotePageDataVaps;
  @Input() productId: any;
  vaps = [];

  constructor() {
  }

  ngOnInit(): void {
  }

  getProductDetails(): void {
    if (this.currentVap?.answer) {
      const answers = this.currentVap?.answer.substring(0, this.currentVap?.answer?.length - 1)?.split(';');

      for (const c of this.collations) {
        const item = {
          description: '',
          value: '',
          checked: false,
          session_item_id: ''
        };
        if (c?.class_id === 18 && c?.entry_type === 'item' && c?.description_1 && c?.product_id === this.productId) {
          item.description = c?.description;
          item.value = c?.description;
          item.session_item_id = c?.session_item_id;
          if (item.description?.length > 10) {
            item.description = item.description.substring(0, 40) + '...';
          }
          for (const ans of answers) {
            if (ans === c?.description) {
              item.checked = true;
            }
          }
          this.vaps.push(item);
        }
      }
    } else {
      for (const c of this.collations) {
        const item = {
          description: '',
          value: '',
          checked: false,
          session_item_id: ''
        };
        if (c?.class_id === 18 && c?.entry_type === 'item' && c?.description_1 && c?.product_id === this.productId) {
          item.description = c?.description;
          item.value = c?.description;
          item.session_item_id = c?.session_item_id;
          item.checked = false;
          if (item.description?.length > 10) {
            item.description = item.description.substring(0, 40) + '...';
          }
          this.vaps.push(item);
        }
      }
    }
  }

  set(item: any, item_id: any): void {
    console.log('item set');
  }

}
